// extracted by mini-css-extract-plugin
module.exports = {"blurbbody":"_2pGXGn","blurbhead":"_3TcjcK","body":"_2y_Jhl","ingress":"_1oOltc","text1":"_2JC0Hs","text2":"_3ypcim","text3":"_1_u4uF"};